import { Handle, Position } from "reactflow";

import styles from "./FullPageLoader.module.scss";

function FullPageLoader({
  message = "Loading initial data",
}: {
  message?: string;
}) {
  return (
    <div className={styles.background}>
      <div className={styles.inner}>
        {message}
        <div className={styles.ripple}>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
}

export default FullPageLoader;
